<template>
  <div>
    <TheAthletesPerformanceOverview
      :class="$style.performanceWrapper"
      :athletes="athletes"
    />
    <div
      id="subMenuNavigationWrapper"
      class="d-flex justify-content-center py-4"
      :class="$style.navigationWrapper"
    >
      <router-link
        :to="{ name: 'round-detail' }"
        @click.native="handleScrollToSubNav"
      >
        <BaseButton
          :variant="$route.name === 'round-detail' ? 'orange' : 'outline-orange'"
          font-size="small"
          left-rounded
        >
          {{ $t('goals') }}
        </BaseButton>
      </router-link>

      <router-link
        :to="{ name: 'round-current-standings' }"
        class="mx-1"
        @click.native="handleScrollToSubNav"
      >
        <BaseButton
          :variant="$route.name === 'round-current-standings' ? 'orange' : 'outline-orange'"
          font-size="small"
        >
          {{ $t('standings') }}
        </BaseButton>
      </router-link>

      <router-link
        :to="{ name: 'round-highlights' }"
        @click.native="handleScrollToSubNav"
      >
        <BaseButton
          :variant="$route.name === 'round-highlights' ? 'orange' : 'outline-orange'"
          font-size="small"
          right-rounded
        >
          {{ $t('highlights') }}
        </BaseButton>
      </router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import TheAthletesPerformanceOverview from '@/components/Molecules/TheAthletesPerformanceOverview'
import BaseButton from '@/components/Atoms/BaseButton'

export default {
  name: 'MyTeamClosedAndLive',
  components: {
    BaseButton,
    TheAthletesPerformanceOverview,
  },
  props: {
    athletes: {
      type: [Array],
      required: true,
    },
  },
  methods: {
    handleScrollToSubNav() {
      VueScrollTo.scrollTo('#subMenuNavigationWrapper', 500, {
        container: 'body',
        offset: document.getElementById('navbar').offsetHeight * -1,
      })
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../assets/scss/variables";
  .navigationWrapper {
    background-color: $color-white;
    border-top: 1px solid $color-windswept-beach;
    border-bottom: 1px solid $color-windswept-beach;
  }
</style>
